// extracted by mini-css-extract-plugin
export default {"tech-cards__title":"tech-cards-page_tech-cards__title__cEuIO"};